export default class CarouselVideo {
    constructor() {
        this.videoTriggers = document.querySelectorAll(".js-carousel-video-trigger");

        if(this.videoTriggers){            
            this.init();
        }
    }

    init() {

        this.videoTriggers.forEach(element => {
            element.addEventListener("click", (e) => {
                e.preventDefault();
                this.startVideo(element);
            });
            element.addEventListener("keydown", (e) => {
                e.preventDefault();
                if (e.code === "Enter") {
                    this.startVideo(element);
                }
            });
        });

        document.addEventListener('fullscreenchange', this.onFullScreenChange, false);
        document.addEventListener('webkitfullscreenchange', this.onFullScreenChange, false);
        document.addEventListener('mozfullscreenchange', this.onFullScreenChange, false);

    }

    onFullScreenChange() {
        let fullscreenElement =
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement;
        if(!fullscreenElement){
            document.querySelectorAll('.js-carousel-video').forEach(element => {
                if(!element.paused){
                    element.pause();
                }
            });
        }
    }

    startVideo(trigger) {
        let video = trigger.previousElementSibling;

        if(video.requestFullscreen){
            video.requestFullscreen();
        } else if(video.webkitRequestFullscreen){
            video.webkitRequestFullscreen();
        } else if(video.msRequestFullScreen){
            video.msRequestFullScreen();
        }
        video.play();
    }
}
